import React, { memo, useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './ZtRecoRate.module.less';

const defaultScore = new Array(5);
defaultScore.fill(null, 0, 5);
export default memo(({ data = {} }) => {
  const [scores, setScores] = useState(0);
  useEffect(() => {
    try {
      const {
        content: { score },
      } = data;
      setScores(+score);
    } catch (err) {
      setScores(0);
    }
  }, [data]);
  return data && data.content ? (
    <div className={styles.card}>
      <span className={styles.text}>推荐指数：</span>
      {defaultScore.map((_, index) => (
        <i
          key={index}
          className={classNames(
            'iconfont icon-zt_score',
            index + 1 > scores ? styles.default : styles.active,
          )}
        />
      ))}
    </div>
  ) : (
    ''
  );
});
